import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Layout } from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { Home, Stethoscope, RefreshCw } from "lucide-react";

const GP_PUNS = [
  "Looks like this page has gone out of practice.",
  "We couldn't find what you're looking for. Perhaps it's been referred elsewhere?",
  "This page seems to have missed its appointment.",
  "404: The page you requested has been struck off.",
  "We've checked the waiting room. This page isn't here.",
  "This URL appears to have discharged itself early.",
  "Sorry, this page is on extended leave.",
  "The page you're seeking has been de-registered.",
];

const NotFound = () => {
  const location = useLocation();
  const [pun, setPun] = useState("");
  const [isSpinning, setIsSpinning] = useState(false);

  const getRandomPun = () => {
    const randomIndex = Math.floor(Math.random() * GP_PUNS.length);
    return GP_PUNS[randomIndex];
  };

  useEffect(() => {
    setPun(getRandomPun());
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  const handleNewPun = () => {
    setIsSpinning(true);
    setTimeout(() => {
      setPun(getRandomPun());
      setIsSpinning(false);
    }, 300);
  };

  return (
    <Layout>
      <section className="section-padding min-h-[60vh] flex items-center">
        <div className="container-narrow text-center">
          {/* Animated stethoscope */}
          <div className="relative mb-6">
            <Stethoscope className="h-20 w-20 mx-auto text-primary animate-bounce" />
          </div>

          <h1 className="font-display text-7xl md:text-9xl font-bold text-primary mb-2">
            404
          </h1>
          
          <h2 className="font-display text-2xl md:text-3xl font-semibold text-foreground mb-6">
            Page not found
          </h2>

          {/* GP Pun with refresh button */}
          <div className="bg-muted/50 rounded-xl p-6 mb-8 max-w-lg mx-auto border border-border">
            <p className="text-lg text-foreground italic mb-4">
              "{pun}"
            </p>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleNewPun}
              className="text-muted-foreground hover:text-primary"
            >
              <RefreshCw className={`h-4 w-4 mr-2 ${isSpinning ? "animate-spin" : ""}`} />
              Another diagnosis
            </Button>
          </div>

          <Link to="/">
            <Button variant="hero" size="lg">
              <Home className="h-4 w-4" />
              Return to Home
            </Button>
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default NotFound;
